<div class="calendar">
    <div class="calendar-navs">
        <!--<div class="month-nav">-->
        <!--<button (click)="prevMonth()">&lt;</button>-->
        <!--<span class="p4">{{ currentDate.format('MMMM') }}</span>-->
        <!--<button (click)="nextMonth()">&gt;</button>-->
        <!--</div>-->
        <!--<div class="year-nav">-->
        <!--<button (click)="prevYear()">&lt;</button>-->
        <!--<span>{{ currentDate.format('YYYY') }}</span>-->
        <!--<button (click)="nextYear()">&gt;</button>-->
        <!--</div>-->
        <div class="flex-wrap" style="align-items: center;">
            <p style="margin: 0; padding: 0">{{currentDate.format('MMMM YYYY') | titlecase}}</p>
            <div class="spacer"></div>
            <div class="flex-wrap">
                <button mat-icon-button (click)="prevMonth()" [disabled]="prevMonthStatus()">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <button mat-icon-button (click)="nextMonth()" [disabled]="nextMonthStatus()">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="month-grid">
        <div class="day-names">
            <div *ngFor="let name of dayNames" class="day-name p9">
                {{ name }}
            </div>
        </div>
        <div class="weeks">
            <div *ngFor="let week of weeks" class="week">
                <ng-container *ngFor="let day of week">
                    <ng-container *ngIf="!day.blocked; else noActionDay">
                        <div class="week-date disabled" *ngIf="!isSelectedMonth(day.mDate)">
                            <span class="date-text">{{ day.mDate.date() }}</span>
                        </div>
                        <div class="week-date enabled"
                             *ngIf="isSelectedMonth(day.mDate)"
                             (click)="selectDate(day)"
                             [ngClass]="{ today: day.today, selected: day.selected }">
                            <span class="date-text">{{ day.mDate.date() }}</span>
                            <ng-container *ngIf="day.warning && !day.selected">
                                <mat-icon
                                        style="color: red; font-size: 12px; vertical-align: middle; line-height: 24px">
                                    warning
                                </mat-icon>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-template #noActionDay>
                        <div class="week-date disabled no-action" style="cursor: not-allowed;">
                            <span class="date-text">{{ day.mDate.date() }}</span>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>